import { Button, Field, Icon, RadioButton, RadioButtonGroup, Select } from "@deligoo/ui"
import { IconName } from "@deligoo/ui/src/icons/build"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import { toast } from "react-toastify"

import { useAppSelector } from "@/App"
import { Card } from "@/components/Card"
import { selectClients } from "@/store/clients"

import { useManualOrderFormContext } from "../AddManualOrderView"
import cls from "../AddManualOrderView.module.scss"
import { ManualOrderKind } from "../useManualOrderForm"

// const orderTypes = ["Order::Manual", "Order::Regular", "Order::Return"] as OrderType[]

export const OrderKindView = () => {
  const clients = useAppSelector(selectClients)

  const { orderKind, formState, setFormStateValue, setNextStep } = useManualOrderFormContext()

  function submitStep() {
    let errorsCount = 0

    toast.dismiss("orderKindType")

    if (!orderKind) {
      errorsCount++

      toast.error("Wybierz rodzaj dostawy", {
        toastId: "orderKindType",
        updateId: "orderKindType",
      })
    }

    if (!errorsCount) setNextStep()
  }

  useEffect(() => {
    if (clients.length && !formState.values.client_id) setFormStateValue({ client_id: clients[0].id })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clients])

  return (
    <Card className={cls.card}>
      <Card.Section>
        <h3>Wybierz typ zlecenia</h3>
      </Card.Section>

      <Card.Section>
        <Field label="Lokalizacja" name="client_id" className={cls.fullWidth} required>
          <Select
            name="client_id"
            value={formState.values.client_id}
            onChange={(e) => setFormStateValue({ client_id: Number(e.currentTarget.value) })}
          >
            {clients?.map((client) => (
              <option value={client.id} key={client.id}>
                {client.name}
              </option>
            ))}
          </Select>
        </Field>
      </Card.Section>

      <Card.Section>
        <Field label="Typ zlecenia">
          <RadioButtonGroup>
            <DeliveryMethod deliveryMethod="pickup_now" />
            <DeliveryMethod deliveryMethod="delivery_only_now" />
            <DeliveryMethod deliveryMethod="delivery_now" />
          </RadioButtonGroup>
        </Field>
      </Card.Section>

      {/* <Card.Section>
        <Field name="type" label="Typ zlecenia">
          <Select
            id="type"
            defaultValue={formState.values.type}
            onChange={(e) => setFormStateValue({ type: e.currentTarget.value as OrderType })}
          >
            {orderTypes.map((orderType) => (
              <option value={orderType} key={orderType}>
                {orderType}
              </option>
            ))}
          </Select>
        </Field>
      </Card.Section> */}

      <Card.Section className={cls.submitBtns}>
        <Button className={cls.submitBtn} color="primary" size="extra-large" fullWidth onClick={submitStep}>
          Przejdź dalej
          <Icon name="short-arrow-tiny-right" />
        </Button>
      </Card.Section>
    </Card>
  )
}

type DeliveryMethodProps = {
  deliveryMethod: ManualOrderKind
}

const DeliveryMethod = ({ deliveryMethod }: DeliveryMethodProps) => {
  const { orderKind, setOrderKind } = useManualOrderFormContext()

  const { t } = useTranslation()

  return (
    <RadioButton
      id={deliveryMethod}
      checked={orderKind === deliveryMethod}
      onChange={() => setOrderKind(deliveryMethod)}
      iconName={getDeliveryMethodIconName(deliveryMethod)}
      required
    >
      {t(`delivery_method.${deliveryMethod}`)}
    </RadioButton>
  )
}

function getDeliveryMethodIconName(orderKind: DeliveryMethodProps["deliveryMethod"]): IconName {
  switch (orderKind) {
    case "pickup_now":
      return "pickup"
    case "delivery_only_now":
      return "delivery"
    case "delivery_now":
      return "paper-bag"
  }
}
